"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidJsonPointer = void 0;
exports.parseJsonPointer = parseJsonPointer;
exports.serializeJsonPointer = serializeJsonPointer;
exports.getFromJsonPointer = getFromJsonPointer;
exports.appendJsonPointer = appendJsonPointer;
/**
 * Escapes a reference token
 *
 * @param str
 * @returns {string}
 */
function escape(str) {
    return typeof str === "string" ? str.toString().replace(/~/g, "~0").replace(/\//g, "~1") : str;
}
/**
 * Unescapes a reference token
 *
 * @param str
 * @returns {string}
 */
function unescape(str) {
    return str.replace(/~1/g, "/").replace(/~0/g, "~");
}
/**
 * Converts a json pointer into a array of reference tokens
 *
 * @param pointer
 * @returns {Array}
 */
function parseJsonPointer(pointer) {
    if (pointer === "") {
        return new Array();
    }
    if (pointer.charAt(0) !== "/") {
        throw new Error("Invalid JSON pointer: " + pointer);
    }
    return pointer.substring(1).split(/\//).map(unescape);
}
/**
 * Builds a json pointer from a array of reference tokens
 *
 * @param refTokens segment of paths.
 * @returns JsonPointer string.
 */
function serializeJsonPointer(refTokens) {
    if (refTokens.length === 0) {
        return "";
    }
    return `/${refTokens.map(escape).join("/")}`;
}
class InvalidJsonPointer extends Error {
}
exports.InvalidJsonPointer = InvalidJsonPointer;
/**
 * Lookup a json pointer in an object
 *
 * @param {Object} obj - object to work on
 * @param {JsonPointer|JsonPointerTokens} pointer - pointer or tokens to a location
 * @returns {*} - value at location, or will throw if location is not present.
 */
function getFromJsonPointer(obj, pointer) {
    const refTokens = Array.isArray(pointer) ? pointer : parseJsonPointer(pointer);
    for (let i = 0; i < refTokens.length; ++i) {
        const tok = refTokens[i];
        if (!(typeof obj === "object" && tok in obj)) {
            throw new InvalidJsonPointer("Invalid reference token: " + tok);
        }
        obj = obj[tok];
    }
    return obj;
}
/**
 * Add a new segment to a json pointer
 * @param pointer Pointer
 * @param suffix Suffix
 * @returns new json pointer
 */
function appendJsonPointer(pointer, ...suffixes) {
    return serializeJsonPointer(parseJsonPointer(pointer).concat(suffixes));
}
//# sourceMappingURL=json-pointer.js.map